import React, { useEffect, useState } from "react";
import { Button } from "reactstrap";

const ProductModal = ({ open, onClose, product, config }) => {
  const [formState, setFormState] = useState({});

  useEffect(() => {
    if (!product || !config) return;

    const state = {};
    const defaultMap = {
      H: product.default_height,
      W: product.default_width,
      D: product.default_depth,
    };

    config.fields.forEach((field) => {
      if (field.type === "dimensions") {
        field.keys.forEach((key, idx) => {
          state[key] = defaultMap[key] || field.values[idx];
        });
      } else if (field.type === "toggle") {
        state[field.label] = "No";
      } else {
        state[field.label] = null;
      }
    });

    setFormState(state);
  }, [product, config]);

  if (!open || !product) return null;

  const handleChange = (label, value, isMultiple = false) => {
    setFormState((prev) => {
      if (isMultiple) {
        const prevValues = prev[label] || [];
        return {
          ...prev,
          [label]: prevValues.includes(value)
            ? prevValues.filter((v) => v !== value)
            : [...prevValues, value],
        };
      }
      return { ...prev, [label]: value };
    });
  };

  return (
    <div className="product-modal">
      <div className="modal-overlay" onClick={onClose}>
        <div className="modal-content" onClick={(e) => e.stopPropagation()}>
          <i className="fa-solid fa-xmark modal-close" onClick={onClose}></i>
          <div className="modal-body">
            <div className="modal-image-col">
              <img
                src={product.image}
                alt={product.name}
                className="img-fluid"
                style={{ objectFit: "contain", height: `${40 + (product.default_height / 2100)*60}%` }}
                />
            </div>
            <div className="modal-form-col small">
              <div className="modal-title mb-3">
                <span className="modal-name fw-semibold">{product.name}</span>
                <span className="modal-sku text-muted small ms-2">
                  ({product.sku})
                </span>
              </div>
              <form className="modal-form">
                {config.fields.map((field, idx) => {
                  if (field.type === "dimensions") {
                    return (
                      <div key={idx} className="mb-1">
                        <div className="modal-label small fw-medium mb-2">
                          Dimensions
                        </div>
                        <div className="d-flex gap-2">
                          {field.keys.map((key, i) => (
                            <input
                              key={i}
                              type="text"
                              className="form-control form-control-sm bg-light text-center"
                              style={{ width: "80px" }}
                              value={formState[key] || ""}
                              onChange={(e) =>
                                setFormState({
                                  ...formState,
                                  [key]: e.target.value,
                                })
                              }
                            />
                          ))}
                        </div>
                      </div>
                    );
                  } else if (field.type === "dropdown") {
                    return (
                      <div className="mb-1" key={idx}>
                        <div className="modal-label small fw-medium mb-2">
                          {field.label}
                        </div>
                        <select
                          className="form-select form-select-sm bg-light"
                          value={formState[field.label] || ""}
                          onChange={(e) =>
                            handleChange(field.label, e.target.value)
                          }
                        >
                          <option value="">Select {field.label}</option>
                          {field.options.map((opt, i) => (
                            <option key={i} value={opt}>
                              {opt}
                            </option>
                          ))}
                        </select>
                      </div>
                    );
                  } else if (
                    field.type === "button-group" ||
                    field.type === "toggle"
                  ) {
                    const isMulti =
                      field.label === "Exposed Sides" ||
                      field.label === "Exposed Side";
                    return (
                      <div key={idx} className="mb-1">
                        <div className="modal-label small fw-medium mb-2">
                          {field.label}
                        </div>
                        <div className="d-flex flex-wrap gap-2">
                          {field.options.map((opt, i) => {
                            const selected = isMulti
                              ? formState[field.label]?.includes(opt)
                              : formState[field.label] === opt;
                            return (
                              <button
                                type="button"
                                key={i}
                                className={`btn btn-sm ${
                                  selected
                                    ? "btn-dark text-white"
                                    : "bg-light btn-outline-dark"
                                }`}
                                style={{
                                  minWidth: "80px",
                                  fontSize: "0.75rem",
                                }}
                                onClick={() =>
                                  handleChange(field.label, opt, isMulti)
                                }
                              >
                                {opt}
                              </button>
                            );
                          })}
                        </div>
                      </div>
                    );
                  }
                  return null;
                })}
                <div className="mt-auto pt-3">
                  <Button
                    color="secondary"
                    className="d-flex align-items-center gap-2 btn-sm w-100 justify-content-center"
                    onClick={() => (window.location.href = "/login_with_otp")}
                  >
                    <i className="fa-solid fa-lock"></i>
                    Login to view price123456
                  </Button>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ProductModal;